<template>
    <div class="buying-choice border-bottom mb-1">
        <div class="row pb-5 m-0">
            
            <div class="col-12">
                <div class="col-12 row">
                    <SelectedDesigns
                        bgColor="#F9F7F3"
                        v-model="selectSize"
                        :list="buyingChoices"
                    />
                    <div class="col-6 col-lg-2 col-md-4 p-0 px-1">
                        <!-- <SelectDesign
                            label="Qty"
                            bgColor="#F9F7F3"
                            v-model="selectQty"
                            :list="qtyList"
                        /> -->
                        <SelectedInputV2
                            label="Qty"
                            bgColor="#F9F7F3"
                            v-model="selectQty"
                            textClass="fw-bolder fs-7"
                        />
                    </div>
                <!-- </div>
                <div class="col-12 col-lg-4 col-md-4 row"> -->
                    <div class="col-6 col-lg-4 col-md-4 p-0 px-1">
                        <SelectedInput
                            :label="`Price ${itemCurrency}`"
                            bgColor="#F9F7F3"
                            :item="total"
                            textClass="fw-bolder fs-7"
                        />
                        <!-- <SelectedInput
                            v-if="availableStock.length"
                            label="Stock"
                            bgColor="#F9F7F3"
                            style="margin-top: 16px !important"
                            :item="availableStock"
                            :textClass="{'text-red': availableStock != 'AVAILABLE' && availableStock.length,'fw-bolder': true}"
                        /> -->
                        <SelectedInput
                            v-if="availableStock.length"
                            label="Stock"
                            bgColor="#F9F7F3"
                            style="margin-top: 16px !important"
                            :item="availableStock"
                            textClass="fw-bolder fs-7"
                        />
                    </div>
                    <div class="col-12 col-lg-8 col-md-8 p-0 px-2" style="padding: 0 12px !important;">
                        <FormBaseButton
                            caption="ADD TO CART"
                            icon=""
                            @click.prevent="addToCart"
                            :loading="loading"
                            class="w-100 rounded-0 fs-7 my-2"
                            color="btn-secondary"
                            style="height: 44px"
                            :disabled="availableStock != 'AVAILABLE'"
                        />
                        <FormBaseButton
                            caption="PROCESS TO CHECKOUT!"
                            icon=""
                            @click.prevent="checkout"
                            :loading="loading"
                            class="w-100 rounded-0 fs-7 my-2"
                            color="btn-secondary"
                            style="height: 44px"
                            :disabled="availableStock != 'AVAILABLE'"
                        />
                        <!-- <p class="text-danger text-center" v-if="addToCartSection?.sku == null && selectQty?.name > 0">Could not found Item With This Variation</p> -->
                    </div>
                </div>
            </div>
        </div>
        <CommonsToaster ref="toaster" />
    </div>
</template>

<script setup>
import { useCartStore } from "@/stores/cart.js";

import { useCurrenciesStore } from "@/stores/currencies-store";
import { useGlobalDiscountStore } from "@/stores/global-discount-store";

import { Skeletor } from "vue-skeletor";
import "vue-skeletor/dist/vue-skeletor.css";

const globalDiscountStore = useGlobalDiscountStore();
const currenciesStore = useCurrenciesStore();
const cartStore = useCartStore();

const props = defineProps({
    section: {
        type: Object,
        default: null,
    },
    item: {
        type: Object,
        default: null,
    },
    finishes: {
        type: String,
        default: "",
    },
});

// const image = ref("");
// const title = ref("");
// const configurePrice = ref("");
// const firstPera = ref("");
// const secondPera = ref("");
// const deliveryInfo = ref(false);
// const returnPolicy = ref(false);
// const returnPolicyText = ref("");
// const model = ref("");
const loading = ref(false);
const toaster = ref(null);
const itemRef = toRef(props, 'item');
const selectedStock = ref(null);

const finishList = ref([
    {
        id: "finish1",
        name: "Grey Mehogony",
    },
    {
        id: "finish2",
        name: "Grey 2 Teak Wood",
    },
    {
        id: "finish3",
        name: "Dark Mehogony",
    },
]);

const qtyList = ref([
    {
        id: "qty0",
        name: 0,
        selected: true,
    },
    {
        id: "qty1",
        name: 1,
    },
    {
        id: "qty2",
        name: 2,
    },
    {
        id: "qty3",
        name: 3,
    },
    {
        id: "qty4",
        name: 4,
    },
    {
        id: "qty5",
        name: 5,
    },
]);


const addToCartSection =ref({
    // image: "/images/no-image.jpg",
    image: "",
    title: "AKHTAR BARAK OBAMA BED",
    configurePrice: "BDT 54999/-",
    firstPera: "",
    secondPera: "Headboard is an oversized piece that cannot be disassembled. We recommend measur",
    deliveryInfo: true,
    returnPolicy: true,
    returnPolicyText: "This item is special order and cannot be returned.",
    model: "AFL-BED-478",
    sku: null
});

const convertPrice = (num) => {
    let val = 0;
    let currency = "BDT";
    if (
        currenciesStore.country &&
        currenciesStore.country.currency != "BDT" &&
        currenciesStore.country.rate > 0
    ) {
        if (num > 0) {
            val = (num / Number(currenciesStore.country.rate)).toFixed(2);
        }
        currency = currenciesStore.country.currency;
    } else {
        val = Number(num).toFixed(2);
    }
    return `${val}`;
};

const itemCurrency = computed(() => {
    let currency = "BDT";
    if (
        currenciesStore.country &&
        currenciesStore.country.currency &&
        currenciesStore.country.currency.length > 0
    ) {
        currency = currenciesStore.country.currency;
    }

    return currency;
});

// Helper function to check if selected SKU matches the discount skuLabel
const checkSkuLabelMatch = (selectedSku, discountSkuLabel) => {
    if (!discountSkuLabel || !selectedSku?.optionValues?.length) return false;
    
    const parts = discountSkuLabel.split(',').map(s => s.trim());
    const discountDimensions = parts[0] || '';
    const discountColor = parts[1] || '';
    const discountMaterial = parts[2] || '';
    
    // Get selected SKU's option values
    let selectedDimensions = '';
    let selectedColor = '';
    let selectedMaterial = '';
    
    selectedSku.optionValues.forEach(opt => {
        const optName = opt.option?.name?.toLowerCase() || '';
        const optDisplayLabel = opt.displayLabel || opt.name || '';
        
        if (optName.includes('dimension') || optName.includes('size')) {
            selectedDimensions = optDisplayLabel;
        } else if (optName.includes('color') || optName.includes('finish') || optName.includes('lacquer')) {
            selectedColor = optDisplayLabel;
        } else if (optName.includes('material') || optName.includes('plywood') || optName.includes('mehgani') || optName.includes('mahogany')) {
            selectedMaterial = optDisplayLabel;
        }
    });
    
    // Check if any of the discount parts match selected SKU values
    // If discount has empty parts, they match anything
    const dimensionsMatch = !discountDimensions || selectedDimensions.includes(discountDimensions) || discountDimensions.includes(selectedDimensions);
    const colorMatch = !discountColor || selectedColor.toLowerCase().includes(discountColor.toLowerCase()) || discountColor.toLowerCase().includes(selectedColor.toLowerCase());
    const materialMatch = !discountMaterial || selectedMaterial.toLowerCase().includes(discountMaterial.toLowerCase()) || discountMaterial.toLowerCase().includes(selectedMaterial.toLowerCase());
    
    return dimensionsMatch && colorMatch && materialMatch;
};

const globalDiscount = computed(() => {
    if (!props.item?.id) {
        return { discountPrice: 0, skuLabel: '' };
    }

    let discountPrice = 0;
    let matchedSkuLabel = '';
    let salesPrice = Number(addToCartSection.value.configurePrice);
    let categoryIds = itemRef.value?.categories;
    // Use itemId or id depending on what's available
    const itemIdValue = props.item?.id || props.item?.itemId;
    // Get the selected SKU if available
    const selectedSku = addToCartSection.value?.sku;

    if (globalDiscountStore?.discounts?.length) {
        globalDiscountStore.discounts.forEach(element => {
            let discount = element.discountType === 'PERCENTAGE' ? Math.floor(salesPrice - salesPrice * Number(element.value) / 100) : salesPrice - Number(element.value);
            
            if (element.type === 'FIXED_CATEGORY' && element.valid) {
                categoryIds.forEach(category => {
                    let findItem = element?.categories?.length && element.categories.filter(i=> i.categoryId.replaceAll("-", "") === category.id.replaceAll("-", ""));
                    if (findItem.length) {
                        discountPrice = discount;
                    }
                });
            }

            if (element.type === 'FIXED_PRODUCT' && element.valid) {
                // For FIXED_PRODUCT, only give discount if skuLabel (dimensions, color, material) matches
                let findItem = element?.items?.length && element.items.filter(i=> {
                    if (i.itemId === itemIdValue) {
                        // Check if skuLabel matches (dimensions, color, material)
                        return checkSkuLabelMatch(selectedSku, i.skuLabel);
                    }
                    return false;
                });
                if (findItem.length) {
                    discountPrice = discount;
                    // Get skuLabel from matched discount item if available
                    if (findItem[0].skuLabel) {
                        matchedSkuLabel = findItem[0].skuLabel;
                    }
                }
            }
        });
    }

    return { discountPrice, skuLabel: matchedSkuLabel };
});

const total = computed(() => {
    let discountedPrice = 0;
    let salesPrice = 0;
    if (currenciesStore?.country?.currency != "BDT" &&
        currenciesStore?.country?.rate > 0
    ) {
        if (globalDiscount.value?.discountPrice > 0) {
            discountedPrice = (
                Number(globalDiscount.value.discountPrice) /
                Number(currenciesStore.country.rate)
            ).toFixed(2);
        }
        if (addToCartSection.value.configurePrice > 0) {
            salesPrice = (
                Number(addToCartSection.value.configurePrice) /
                Number(currenciesStore.country.rate)
            ).toFixed(2);
        }
    } else {
        if (globalDiscount.value?.discountPrice > 0) {
            discountedPrice = Number(globalDiscount.value.discountPrice);
        }
        if (addToCartSection.value.configurePrice > 0) {
            salesPrice = Number(addToCartSection.value.configurePrice);
        }
    }
    let price = discountedPrice > 0 ? discountedPrice : salesPrice;

    // return {
    //     discountedPrice: discountedPrice,
    //     salesPrice: salesPrice,
    // };

    return Math.round(price).toLocaleString();
});


const selectFinish = ref(finishList.value[0]);
// const selectSize = ref(sizeList.value[0]);
const selectSize = ref([]);
// const selectQty = ref(qtyList.value[0]);
const selectQty = ref(0);

const addToCart = async () => {
    // if (addToCartSection.value?.sku?.code?.length && selectQty.value?.name > 0) {
    if (availableStock.value == 'AVAILABLE') {
        let submitData = {
            product: JSON.parse(JSON.stringify(props.item)),
            quantity: selectQty.value,
            sku: addToCartSection.value.sku,
        };
        
        if (props.item?.id?.length) {
            cartStore.addToCart(submitData);
            toaster.value.success(`Added to Your Cart`, 1500);
        } else {
            toaster.value.error(`Please select options`, 1500);
        }
    }
};

const checkout = async () => {
    await addToCart();
    navigateTo('cart')    
};

const setFinishes = () => {
    if (props.finishes?.length) {
        selectFinish.value = finishList.value.filter(
            (i) => i.name.toLowerCase() === props.finishes
        )[0];
    }
};

// const setSelectors = () => {
//     if (props.section) {
//         image.value = props.section.image;
//         title.value = props.section.title;
//         configurePrice.value = props.section.configurePrice;
//         firstPera.value = props.section.firstPera;
//         secondPera.value = props.section.secondPera;
//         deliveryInfo.value = props.section.deliveryInfo;
//         returnPolicy.value = props.section.returnPolicy;
//         returnPolicyText.value = props.section.returnPolicyText;
//         model.value = props.section.model;
//     }
// };

const buyingChoices = computed(() => {
    let inputArray = [];
    if (props?.item?.skus?.length) {
        props.item.skus.forEach((sku) => {
            if (sku?.optionValues?.length) {
                sku.optionValues.forEach((value) => {
                    inputArray.push({
                        optionName: value?.option?.name,
                        optionDisplayLabel: value?.option?.displayLabel,
                        optionId: value?.option?.id,
                        displayLabel: value?.displayLabel,
                        name: value?.name,
                        id: value?.id,
                    });
                });
            }
        });
    }

    const result = {};

    inputArray.forEach((item) => {
        const { optionName, optionDisplayLabel, optionId, displayLabel, name, id } = item;

        if (!result[optionDisplayLabel]) {
            result[optionDisplayLabel] = {};
        }

        if (!result[optionDisplayLabel][optionId]) {
            result[optionDisplayLabel][optionId] = [{id: "Selected-One", name: "Select One", selected: true}];
        }

        let index = result[optionDisplayLabel][optionId].findIndex(i => i.id == id && i.name == displayLabel);
        if (index == -1) {
            result[optionDisplayLabel][optionId].push({ name: displayLabel, id: id, optionDisplayLabel: optionDisplayLabel, optionId: optionId, selected: false});
            // result[optionDisplayLabel][optionId].push({ name: displayLabel, valueId: id, id: `${id}-${optionId}`, optionDisplayLabel: optionDisplayLabel, optionId: optionId, selected: false});
        }
    });

    const finalArray = [];
    for (const optionName in result) {
        for (const optionId in result[optionName]) {
            finalArray.push({
                optionName,
                optionId,
                values: result[optionName][optionId],
            });
        }
    }

    // finalArray.forEach(element => {
    //     // console.log(element.optionName);
    //     // if (selectedOptions.value != null) {
    //     //     console.log(Object.keys(selectedOptions.value))
    //     // }
    //     selectedOptions.value[element.optionName] = "null";
    //     // console.log("selectedOptions.value");
    //     // console.log(selectedOptions.value);
    // });

    // return finalArray;
    return finalArray.sort((x,y) => x.optionId - y.optionId);
});

const availableStock = computed(() => {

    let totalStock = selectedStock.value?.ok > 0 ? selectedStock.value.ok : 0;
    let skuCode = selectedStock.value?.skuCode?.length ? selectedStock.value.skuCode : "";
    let selectedQuantity = selectQty.value;
    // let selectedQuantity = selectQty.value?.name > 0 ? selectQty.value.name : 0;
    if (skuCode == addToCartSection.value?.sku?.code && totalStock >= selectedQuantity) {
        return "AVAILABLE";
    } else if (skuCode == addToCartSection.value?.sku?.code && totalStock != 0 && totalStock < selectedQuantity) {
        return "NOT ENOUGH";
    } else if (skuCode == addToCartSection.value?.sku?.code && totalStock < selectedQuantity) {
        return "STOCK OUT";
        // return "OUT OF STOCK";
    }
    return "";
});

function findMatchingObject(skus, size) {
  return skus.find((sku) => {
    if (
      size.every((sizeOption) =>
        sku.optionValues.some(
          (skuOption) =>
            skuOption.optionId === sizeOption.optionId &&
            skuOption.id === sizeOption.id
        )
      )
    ) {
      return true;
    }
    return false;
  });
}

watch(selectSize,
    (newVal) => {
        if (newVal.length == buyingChoices.value.length && itemRef.value?.skus?.length) {
            // let hasSku = props.item.skus.filter( i => {
            //     // return i.optionValues.some( s => s)
            // })
            let skusArr = itemRef.value?.skus;
            let stocks = itemRef.value?.stocks;
            if (skusArr.length) {
                let matchingSku = findMatchingObject(skusArr, newVal);
                if (matchingSku) {
                    addToCartSection.value.configurePrice = matchingSku?.salesPrice ? matchingSku.salesPrice : 0;
                    addToCartSection.value.sku = matchingSku;
                    let hasStock = stocks.filter(i => i.skuCode == matchingSku.code && i.itemId == matchingSku.itemId);
                    if (hasStock.length) {
                        selectedStock.value = hasStock[0];
                    }
                } else {
                    console.log('No matching SKU found');
                }
            }

        }
    },
    { immediate: true, deep: true }
);

watch(()=> props.item,
    (newVal) => {
        if (newVal?.title?.length) {
            let skus = props.item?.skus?.length ? props.item.skus : [];
            let images = props.item?.images?.length ? props.item.images : [];
            addToCartSection.value.image = images?.length ? images[0]?.url : 0;
            addToCartSection.value.title = props.item.title;
            addToCartSection.value.configurePrice = skus?.length ? skus[0]?.salesPrice : 0;
            addToCartSection.value.model = props.item.model;

        }
    },
    { immediate: true, deep: true }
);
</script>

<style lang="scss">
.details-bg-color {
    background-color: #f9f7f3;
}
</style>
